// libs
import { computed, reactive, ref, watch } from 'vue'

// classes
import Url from '../classes/Url'
import CookieParser from '../classes/CookieParser'

// services
import getCompany from '../api/company/getCompany'
import getCompanies from '../api/companies/getCompanies'
// import axios from 'axios'

// composables
import useLoading from './useLoading'

/**
 * GLOBALS
 */
// const VALID_WEBSITES = new Set(['fr-FR', 'nl-NL', 'en-US', 'fr-FR-CSE'])
const VALID_WEBSITES = new Set(['www.travelski.com','nl.travelski.com','uk.travelski.com','cse.travelski.com'])

// const WEBSITES_WITH_COMPANIES = new Set(['fr-FR-CSE'])
const WEBSITES_WITH_COMPANIES = new Set(['cse.travelski.com'])

//const DEFAULT_LOCALE = 'fr-FR'
const DEFAULT_WEBSITE = 'www.travelski.com'
const DEFAULT_COMPANY = 'cgos' // TODO: remove later. default for now

/**
 * REACTIVE DATA
 */
// let items = ref([])
const COMPANIES = ref([])
// const website = ref(DEFAULT_LOCALE)
const website = ref(DEFAULT_WEBSITE)

const company = reactive({
    name: Url.hash.company || '',
    data: {}
})
const domain = computed(() => {
    return {
        'www.travelski.com': `www.travelski.com`,
        'uk.travelski.com': `uk.travelski.com`,
        'nl.travelski.com': `nl.travelski.com`,
        'cse.travelski.com': `cse.travelski.com`
    }[website.value]
})
const entityPath = computed(() => {
    return generateEntityPath(website.value, company.name)
})

/**
 * PRIVATE METHODS
 */
const _persistSiteData = () => {
    const dataObj = { website: website.value }

    // if the company is hidden, don't persist the data
    if(company.data.isHidden) return

    if (company.name) {
        if (WEBSITES_WITH_COMPANIES.has(website.value)) {
            dataObj.company = company.name
        } else if (Url.hash.company) {
            Url.removeHash('company')
        }
    }

    Url.addHashObj(dataObj)
    CookieParser.setCookies(dataObj)
}
const _setWebsite = async () => {
    const websiteFromURL = VALID_WEBSITES.has(Url.hash.website) ? Url.hash.website : ''
    const websiteFromCookie = VALID_WEBSITES.has(CookieParser.cookies.website) ? CookieParser.cookies.website : ''

    // match first one not falsey
    website.value = websiteFromURL || websiteFromCookie || DEFAULT_WEBSITE

    Url.addHash('website', website.value)
    CookieParser.setCookies({ website: website.value })
}
const _isValidCompany = (companyName) => {
    return COMPANIES.value.some(({ CompanyName }) => CompanyName === companyName)
}
const _setCompany = async () => {
    // if the company is hidden, don't setCompany
    if(company.data.isHidden) return

    let companyFromURL = Url.hash.company
    let companyFromCookie = CookieParser.cookies.company

    companyFromURL = _isValidCompany(companyFromURL) ? companyFromURL : ''
    companyFromCookie = _isValidCompany(companyFromCookie) ? companyFromCookie : ''

    company.name = companyFromURL || companyFromCookie || DEFAULT_COMPANY

    if (!WEBSITES_WITH_COMPANIES.has(website.value) && Url.hash.company) {
        Url.removeHash('company')
    } else if (WEBSITES_WITH_COMPANIES.has(website.value) && company.name) {
        Url.addHash('company', company.name)
    }

    CookieParser.setCookies({ company: company.name })
}
const _setCompanyList = async (idToken) => {
    const { results } = await getCompanies({
        filter: {},
        sort: {
            field: 'CompanyName',
            direction: 'ASC'
        },
        page: 0,
        // resultsPerPage: 10
    },
    idToken)

    // this object is read only
    COMPANIES.value = Object.freeze(results)
}

// const _getMenuConfig = async () => {
//     // const url = `${endpoints.b2b.singleCompany}?companyName=${companyName}`
//     const url = '/static/DEV-menu.json'
//     let { data } = await axios.get(url)

//     items = Object.freeze(data)
//     console.log('items useSite',items)
// }


/**
 * PUBLIC METHODS
 */
const generateEntityPath = (website, companyName) => {
    return {
        'www.travelski.com': `www.travelski.com`,
        'uk.travelski.com': `uk.travelski.com`,
        'nl.travelski.com': `nl.travelski.com`,
        'cse.travelski.com': `cse.travelski.com/${companyName}`
    }[website]
}
const init = (user) => async () => {
    const {startLoadingThis, stopLoadingThis} = useLoading()
    startLoadingThis()
    // TODO: Hot fix.  Find a way to make sure other composables don't get called if auth doesn't succeed
    if (user.getIdToken() || process.env.NODE_ENV === "development") await _setCompanyList(user.getIdToken())

    await Promise.all([_setWebsite(), _setCompany()])

    stopLoadingThis()
}

/**
 * COMPOSABLE
 */
const useSite = (user) => {
    const {startLoadingThis, stopLoadingThis} = useLoading()
    const updateCompany = async () => {
        if (!company.name || !WEBSITES_WITH_COMPANIES.has(website.value)) return
        try {
            startLoadingThis()
            company.data = await getCompany(company.name, user.getIdToken())
        } finally {
            stopLoadingThis()
        }
    }

    watch([() => company.name, () => website.value], updateCompany)
    watch([() => company.name, () => website.value], _persistSiteData)

    return {
        website,
        company,
        entityPath,
        domain,
        generateEntityPath,
        init: init(user),
        consts: { WEBSITES_WITH_COMPANIES, COMPANIES }
    }
}

export default useSite
